import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from "./components/layout/header/header.component";
import { FooterComponent } from "./components/layout/footer/footer.component";
import { AccesibilityComponent } from './components/layout/accesibility/accesibility.component';
import { GoUpComponent } from './components/layout/go-up/go-up.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { HttpErrorInterceptor, CachingInterceptor, AuthInterceptor } from "@interceptors";
import { DemoNgZorroAntdModule } from "./modules/ng-antd.module";
import { LegalPersonProfileComponent } from './components/legal-person-profile/legal-person-profile.component';
import { NaturalPersonProfileComponent } from './components/natural-person-profile/natural-person-profile.component';
import {ReactiveFormsModule} from "@angular/forms";
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
import { PoliticaDatosPersonalesComponent } from './components/politica-datos-personales/politica-datos-personales.component';
import {PendingChangesGuard} from "./guards/pending-changes.guard";


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AccesibilityComponent,
    GoUpComponent,
    LegalPersonProfileComponent,
    NaturalPersonProfileComponent,
    RecoverPasswordComponent,
    PoliticaDatosPersonalesComponent

  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    AccesibilityComponent,
    GoUpComponent
  ],
    imports: [
        CommonModule,
        HttpClientModule,
        DemoNgZorroAntdModule,
        ReactiveFormsModule
    ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CachingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    PendingChangesGuard
  ]
})
export class CoreModule {
}
